/***
 * @Authors:
 *      Ashwin Rai (ashwinrai.com)
 *      Nikhil Chougule
 ***/

/*** Imports ***/

/* Library imports */

/* Component imports */

/* Style imports */


/*** End Imports ***/

export default window.Content = window.Content || {};


// WEBPACK FOOTER //
// ./src/content/Content.js